const setArrayValues = item => {
  return item.values[0]?.id ? item.values.map(val => val.id) : item.values;
};

const generateValues = item => {
  if (item.attribute_key === 'content') {
    const values = item.values || '';
    return values.split(',');
  }
  if (Array.isArray(item.values)) {
    return setArrayValues(item);
  }
  if (typeof item.values === 'object') {
    return [item.values.id];
  }
  if (!item.values) {
    return [];
  }
  return [item.values];
};

const generatePayload = data => {
  // Make a copy of data to avoid vue data reactivity issues
  const filters = JSON.parse(JSON.stringify(data));
  let payload = filters.map(item => {
    // If item key is content, we will split it using comma and return as array
    // FIX ME: Make this generic option instead of using the key directly here
    item.values = generateValues(item);
    return item;
  });

  // For every query added, the query_operator is set default to and so the
  // last query will have an extra query_operator, this would break the api.
  // Setting this to null for all query payload
  payload[payload.length - 1].query_operator = undefined;
  return { payload };
};

// Pastas criadas por versões antigas podem ter preservado um query_operator
// no último critério. Isso produz SQL com AND/OR sobrando no backend e deixa a
// lista presa no loading. Normalize a consulta salva sem alterar o objeto do
// Vuex, mantendo operadores somente entre critérios.
export const normalizeSavedFilterQuery = query => {
  const payload = Array.isArray(query?.payload) ? query.payload : [];

  return {
    payload: payload.map((item, index) => {
      const normalizedItem = { ...item };
      const isLastItem = index === payload.length - 1;

      if (isLastItem) {
        delete normalizedItem.query_operator;
      } else {
        const queryOperator = String(
          normalizedItem.query_operator || 'and'
        ).toLowerCase();
        normalizedItem.query_operator = ['and', 'or'].includes(queryOperator)
          ? queryOperator
          : 'and';
      }

      return normalizedItem;
    }),
  };
};

export default generatePayload;
